import { UNGROUPED_RESOURCES_GROUP_ID } from '@/console/features/groups/components/group-list/group-list.constants';

import { api } from '../../_generated/api/assets-api.generated';

export const devicesApi = api.enhanceEndpoints({
  addTagTypes: [
    'Groups',
    'Device',
    'DeviceConnectivityStatus',
    'DeviceSyncStatus',
  ],
  endpoints: {
    ReadAllDevices: {
      providesTags: (_, __, args) => {
        const tags = [{ type: 'Device' as const, id: 'LIST' }];
        const filteredGroup = args?.filter?.groupId;
        const groupId = filteredGroup?.contains ?? UNGROUPED_RESOURCES_GROUP_ID;
        if (filteredGroup) {
          return [...tags, { type: 'Groups' as const, id: groupId }];
        }
        return tags;
      },
    },
    ReadDevice: {
      providesTags: (_, __, args) => [
        { type: 'Device' as const, id: args.deviceId },
      ],
    },
    CreateDevice: {
      invalidatesTags: [
        { type: 'Device' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    UpdateDevice: {
      invalidatesTags: (_, __, arg) => [
        { type: 'Device' as const, id: arg.deviceId },
        { type: 'DeviceConnectivityStatus' as const, id: arg.deviceId },
        { type: 'Device' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    DeleteDevice: {
      invalidatesTags: [
        { type: 'Device' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    ReadLinkedProjectsForDevice: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Device' as const, id: arg.deviceId }];
      },
    },
    ReadDeviceFirmwareInformation: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Device' as const, id: arg.deviceId }];
      },
    },
    ReadDeviceConnectivityStatus: {
      providesTags: (_, __, arg) => {
        return [
          { type: 'DeviceConnectivityStatus' as const, id: arg.deviceId },
        ];
      },
    },
    ReadDeviceSyncStatus: {
      providesTags: (_, __, arg) => {
        return [{ type: 'DeviceSyncStatus' as const, id: arg.deviceId }];
      },
    },
  },
});

export const {
  useDeleteDeviceMutation,
  useCreateDeviceMutation,
  useReadAllDevicesQuery,
  useUpdateDeviceMutation,
  useReadDeviceQuery,
  useReadDevicesByIdsQuery,
  useReadLinkedProjectsForDeviceQuery,
  useReadDeviceSyncStatusQuery,
  useLazyReadDeviceSyncStatusQuery,
  useReadDeviceNamesForRoleRowQuery,
  useReadDeviceConnectivityStatusQuery,
  useReadDeviceFirmwareInformationQuery,
} = devicesApi;
